(() => {
  'use strict';
  const config = window.SWTheme || {};
  const root = config.root || '/';
  const cartURL = config.cart || root + 'cart';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  let cartBusy = false;
  let observer;
  let scrollLockCount = 0;
  let originalOverflow = '';
  function openDialog(dialog, opener) {
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return false;
    dialog._opener = opener || document.activeElement;
    if (!scrollLockCount) { originalOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
    scrollLockCount++;
    dialog.showModal();
    dialog._opener?.setAttribute('aria-expanded', 'true');
    if (!dialog._closeBound) {
      dialog._closeBound = true;
      dialog.addEventListener('close', () => {
        scrollLockCount = Math.max(0, scrollLockCount - 1);
        if (!scrollLockCount) document.body.style.overflow = originalOverflow;
        if (dialog._opener?.isConnected) {
          dialog._opener.setAttribute('aria-expanded', 'false');
          dialog._opener.focus({ preventScroll: true });
        }
      });
      dialog.addEventListener('click', e => {
        if (e.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
      });
    }
    return true;
  }
  async function jsonFetch(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    let data;
    try { data = await response.json(); } catch (_) { throw new Error('Die Antwort konnte nicht geladen werden. Bitte versuche es erneut.'); }
    if (!response.ok || (data.status && Number(data.status) >= 400)) {
      const message = typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'Die Änderung ist gerade nicht möglich. Bitte prüfe Menge und Verfügbarkeit.';
      throw new Error(message);
    }
    return data;
  }
  function sections() {
    const ids = ['sw-cart-drawer'];
    const page = $('[data-cart-page]');
    if (page?.dataset.sectionId) ids.push(page.dataset.sectionId);
    return ids;
  }
  function renderCart(htmlSections) {
    let drawerOK = false;
    Object.entries(htmlSections || {}).forEach(([id, html]) => {
      if (typeof html !== 'string' || !html.trim()) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'sw-cart-drawer') {
        const next = $('[data-drawer-content]', doc), current = $('[data-drawer-content]');
        if (next && current) { current.innerHTML = next.innerHTML; drawerOK = true; }
      } else {
        const next = $('[data-cart-page-content]', doc), current = $('[data-cart-page-content]');
        if (next && current) current.innerHTML = next.innerHTML;
      }
    });
    return drawerOK;
  }
  async function refreshCart(response) {
    let drawerOK = renderCart(response.sections);
    if (!drawerOK) {
      try {
        const url = new URL(cartURL, location.origin);
        url.searchParams.set('sections', sections().join(','));
        drawerOK = renderCart(await jsonFetch(url.href));
      } catch (_) { /* cart mutation succeeded; only the view needs a page fallback */ }
    }
    try {
      const state = typeof response.item_count === 'number' ? response : await jsonFetch(cartURL + '.js');
      $$('[data-cart-count]').forEach(el => { el.textContent = String(state.item_count); });
      $('.sw-cart-live')?.replaceChildren(document.createTextNode('Warenkorb aktualisiert. ' + state.item_count + ' Artikel.'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
    } catch (_) { /* keep successful cart contents and checkout usable */ }
    return drawerOK;
  }
  function gallery(rootEl, id) {
    const panels = $$('[data-media-id]', rootEl);
    if (!panels.length) return;
    const match = panels.find(p => p.dataset.mediaId === String(id)) || panels[0];
    $('.sw-gallery', rootEl)?.classList.add('sw-gallery-enhanced');
    panels.forEach(panel => {
      panel.hidden = panel !== match;
      if (panel !== match) $$('video', panel).forEach(v => v.pause());
    });
    $$('[data-media-target]', rootEl).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mediaTarget === match.dataset.mediaId)));
  }
  function setVariant(el, variant, updateURL = true) {
    const select = $('[data-variant-select]', el);
    const status = $('[data-product-status]', el);
    if (status) { status.textContent = ''; status.classList.remove('sw-error'); }
    el._variant = variant;
    if (variant) {
      select.value = String(variant.id);
      select.disabled = false;
      $('[data-price]', el).textContent = variant.price;
      const compare = $('[data-compare]', el), discount = $('[data-discount]', el);
      compare.hidden = !variant.compare; compare.textContent = variant.compare || '';
      discount.hidden = !variant.discount; discount.textContent = variant.discount ? '−' + variant.discount + '%' : '';
      $('[data-sw-price]', el).hidden = false;
      if ($('[data-sticky-price]', el)) $('[data-sticky-price]', el).textContent = variant.price;
      const quantity = $('[name="quantity"]', el);
      quantity.min = variant.min || 1; quantity.step = variant.step || 1;
      if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
      const current = Number(quantity.value) || Number(quantity.min);
      quantity.value = Math.max(Number(quantity.min), Math.min(variant.max || Infinity, current));
      if (variant.media) gallery(el, variant.media);
      if (updateURL) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    } else {
      select.value = ''; select.disabled = true;
      $('[data-sw-price]', el).hidden = true;
      if ($('[data-sticky-price]', el)) $('[data-sticky-price]', el).textContent = '';
    }
    const available = Boolean(variant?.available);
    const label = !variant ? 'Nicht verfügbar' : available ? 'In den Warenkorb' : 'Ausverkauft';
    $('[data-add-to-cart]', el).disabled = !available;
    $('[data-atc-label]', el).textContent = label;
    const sticky = $('[data-sticky-add]', el);
    if (sticky) { sticky.disabled = !available; sticky.textContent = label; }
    const selected = $$('[data-option-index]', el).map(f => $('input:checked', f)?.value);
    $$('[data-option-index]', el).forEach((field, index) => {
      $('[data-option-value]', field).textContent = selected[index] || '';
      $$('input[type=radio]', field).forEach(input => {
        const possible = el._variants.some(v => v.available && v.options.every((o, i) => o === (i === index ? input.value : selected[i])));
        input.closest('label').classList.toggle('sw-unavailable', !possible);
        input.title = possible ? input.value : input.value + ' – aktuell nicht verfügbar';
      });
    });
  }
  function initProduct(el) {
    if (el._ready) return;
    const script = $('[data-variant-json]', el);
    if (!script) return;
    try { el._variants = JSON.parse(script.textContent); } catch (_) { return; }
    el._ready = true;
    const select = $('[data-variant-select]', el);
    const optionFields = $$('[data-option-index]', el);
    const options = $('.sw-variant-options', el);
    if (options) options.hidden = false;
    $('.sw-native-variant', el).hidden = true;
    gallery(el, el.dataset.selectedMedia);
    setVariant(el, el._variants.find(v => String(v.id) === select.value), false);
    el.addEventListener('change', e => {
      if (!e.target.matches('.sw-option-list input')) return;
      const values = optionFields.map(field => $('input:checked', field)?.value);
      const match = el._variants.find(v => v.options.every((value, i) => value === values[i]));
      setVariant(el, match);
    });
    const atc = $('[data-add-to-cart]', el), sticky = $('.sw-sticky-buy', el);
    if (sticky && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, { threshold: 0 });
      stickyObserver.observe(atc);
      el._stickyObserver = stickyObserver;
    }
  }
  function init(scope = document) {
    $$('[data-sw-product]', scope).forEach(initProduct);
    if (config.motion && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('sw-reveal-ready');
      if (!observer) observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('sw-is-visible'); observer.unobserve(entry.target); } }), { threshold: .08 });
      $$('[data-sw-reveal]', scope).forEach(el => observer.observe(el));
    }
  }
  document.addEventListener('click', e => {
    const menu = e.target.closest('[data-open-menu]');
    if (menu) { openDialog($('#SWMenu'), menu); return; }
    const cart = e.target.closest('[data-open-cart]');
    if (cart && !e.metaKey && !e.ctrlKey && openDialog($('#SWCart'), cart)) { e.preventDefault(); return; }
    const close = e.target.closest('[data-close-dialog]');
    if (close) { close.closest('dialog')?.close(); return; }
    if (e.target.closest('#SWMenu a')) $('#SWMenu')?.close();
    const thumb = e.target.closest('[data-media-target]');
    if (thumb) { gallery(thumb.closest('[data-sw-product]'), thumb.dataset.mediaTarget); return; }
    const zoom = e.target.closest('[data-image-zoom]');
    if (zoom && !e.metaKey && !e.ctrlKey && 'HTMLDialogElement' in window) {
      e.preventDefault(); let dialog = $('#SWImageZoom');
      if (!dialog) { dialog = document.createElement('dialog'); dialog.id = 'SWImageZoom'; dialog.className = 'sw-image-dialog'; dialog.setAttribute('aria-label', 'Produktbild vergrößert'); dialog.innerHTML = '<button class="sw-icon-button" type="button" data-close-dialog aria-label="Bild schließen">✕</button><img alt="">'; document.body.append(dialog); }
      const img = $('img', dialog); img.src = zoom.href; img.alt = $('img', zoom)?.alt || 'Produktbild'; openDialog(dialog, zoom); return;
    }
    const step = e.target.closest('[data-quantity-step]');
    if (step) {
      const input = $('input', step.parentElement), n = Number(input.value) || Number(input.min) || 1;
      const increment = Number(input.step) || 1;
      input.value = Math.min(input.max ? Number(input.max) : Infinity, Math.max(Number(input.min) || 1, n + Number(step.dataset.quantityStep) * increment));
      input.dispatchEvent(new Event('change', { bubbles: true })); return;
    }
    const cartStep = e.target.closest('[data-cart-step]'), remove = e.target.closest('[data-cart-remove]');
    if (cartStep || remove) {
      e.preventDefault(); if (cartBusy) return;
      const item = (cartStep || remove).closest('[data-cart-key]');
      const input = $('[data-cart-quantity]', item);
      let quantity = 0;
      if (cartStep) {
        quantity = (Number(input.value) || 0) + Number(cartStep.dataset.cartStep) * (Number(input.step) || 1);
        if (quantity < Number(input.min || 1)) quantity = 0;
        if (input.max) quantity = Math.min(quantity, Number(input.max));
      }
      mutateCart(item, quantity); return;
    }
    const dropdownSummary = e.target.closest('.sw-nav-dropdown summary');
    if (dropdownSummary) $$('.sw-nav-dropdown[open]').forEach(d => { if (d !== dropdownSummary.parentElement) d.open = false; });
    else if (!e.target.closest('.sw-nav-dropdown')) $$('.sw-nav-dropdown[open]').forEach(d => d.open = false);
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') $$('.sw-nav-dropdown[open]').forEach(d => d.open = false); });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-cart-quantity]')) {
      if (!e.target.checkValidity()) { e.target.reportValidity(); return; }
      mutateCart(e.target.closest('[data-cart-key]'), Number(e.target.value));
    }
  });
  async function mutateCart(item, quantity) {
    if (cartBusy || !item || !Number.isInteger(quantity) || quantity < 0) return;
    cartBusy = true;
    const form = item.closest('form'), status = $('[data-cart-error]', form);
    const key = item.dataset.cartKey;
    if (status) status.textContent = '';
    $$('[data-cart-form]').forEach(f => f.setAttribute('aria-busy', 'true'));
    const note = $('[data-cart-page] [name=note]');
    if (note) form._noteValue = note.value;
    try {
      const response = await jsonFetch(cartURL + '/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: sections(), sections_url: location.pathname }) });
      const ok = await refreshCart(response);
      if (!ok) { location.assign(cartURL); return; }
      const currentNote = $('[data-cart-page] [name=note]');
      if (currentNote && form._noteValue !== undefined) currentNote.value = form._noteValue;
      const activeScope = $('#SWCart')?.open ? $('#SWCart') : $('[data-cart-page]');
      const nextItem = $$('[data-cart-key]', activeScope || document).find(el => el.dataset.cartKey === key);
      if (nextItem) $('[data-cart-quantity]', nextItem)?.focus({ preventScroll: true });
      else if ($('#SWCart')?.open) $('[data-close-dialog]', $('#SWCart'))?.focus();
    } catch (error) { if (status) status.textContent = error.message; }
    finally { cartBusy = false; $$('[data-cart-form]').forEach(f => f.removeAttribute('aria-busy')); }
  }
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!form.matches('.sw-product-form')) return;
    const product = form.closest('[data-sw-product]');
    if (!product?._ready) return;
    e.preventDefault();
    const button = $('[data-add-to-cart]', product), status = $('[data-product-status]', product);
    if (form.dataset.busy === 'true' || !product._variant?.available) return;
    if (!form.reportValidity()) return;
    form.dataset.busy = 'true'; button.disabled = true;
    const sticky = $('[data-sticky-add]', product); if (sticky) sticky.disabled = true;
    $('[data-atc-label]', product).textContent = 'Wird hinzugefügt …';
    status.classList.remove('sw-error'); status.textContent = '';
    const data = new FormData(form); data.set('sections', sections().join(',')); data.set('sections_url', location.pathname);
    try {
      const response = await jsonFetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      status.textContent = 'Zum Warenkorb hinzugefügt.';
      const ok = await refreshCart(response);
      if (ok) { if (!openDialog($('#SWCart'), e.submitter || button)) location.assign(cartURL); }
      else location.assign(cartURL);
    } catch (error) { status.textContent = error.message; status.classList.add('sw-error'); }
    finally {
      delete form.dataset.busy;
      const available = Boolean(product._variant?.available);
      button.disabled = !available;
      $('[data-atc-label]', product).textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
      if (sticky) sticky.disabled = !available;
    }
  });
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => { $$('[data-sw-product]', e.target).forEach(p => p._stickyObserver?.disconnect()); });
  document.addEventListener('shopify:section:select', e => { $$('[data-sw-reveal]', e.target).forEach(el => el.classList.add('sw-is-visible')); });
  init();
})();
